import {JWSUserType, userFromToken} from "../model/JWS";

export const isVerifiedAdmin = (usertoken: string | undefined) => {
    return usertoken !== undefined && userFromToken(usertoken)["user-type"] === JWSUserType.ADMIN
}